<ion-grid class="max-w-1336 content-box" *ngIf="getPropertyList$
| async as propertyList">
	<ng-container *ngIf="propertyList.isSkeleton">
		<ion-grid class="side-menu-wrapper text-center">
			<ion-spinner class="ion-spinner"></ion-spinner>
		</ion-grid>
	</ng-container>
	<ion-row>
		<ion-col size="6">
			<ion-button (click)="copyPropertyForm()">Copy Property</ion-button>
		</ion-col>
		<ion-col size="6">
			<ion-button (click)="onSave(propertyList.data)">Save Property</ion-button>
		</ion-col>
		<ion-col col="12">

			<ion-grid class="box">
				<ion-row class="header">
					<ion-col>
						Title
					</ion-col>
					<ion-col class="text-center">
						Value
					</ion-col>
					<ion-col>
						Description
					</ion-col>
				</ion-row>
				<ion-row *ngFor="let propertyList of propertyList.data">
					<ion-col>
						{{ propertyList.name }}
					</ion-col>
					<ion-col>
						<ng-container *ngIf="propertyList.format === 'Json'">
							<json-editor [(ngModel)]="propertyList.value"></json-editor>
						</ng-container>
						<ng-container *ngIf="propertyList.format === 'String'">
							<ion-input type="text" class="input" [(ngModel)]="propertyList.value"></ion-input>
						</ng-container>
						<ng-container *ngIf="propertyList.format === 'Integer'">
							<ion-input type="number" class="input" [(ngModel)]="propertyList.value"></ion-input>
						</ng-container>
						<ng-container *ngIf="propertyList.format === 'Boolean'">
							<ion-checkbox [(ngModel)]="propertyList.value"> </ion-checkbox>
						</ng-container>
						<ng-container *ngIf="propertyList.format === 'Timestamp'">
							<ion-input type="text" class="input" [(ngModel)]="propertyList.value" mbsc-datepicker
								[controls]="['date', 'time']" dateFormat="DD/MM/YYYY" [buttons]="['set', 'cancel']"
								timeFormat="hh:mm A"></ion-input>
						</ng-container>
					</ion-col>
					<ion-col>
						{{ propertyList.description }}
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>